









































import { Models } from '@mtap-smartcity/api';
import {
  Component, Prop, Vue, Watch
} from 'vue-property-decorator';

interface Parameter {
  name: string,
  displayName: string,
  value: string | number,
  type: 'string' | 'number' | 'address'
}

@Component
export default class ScenarioPropertiesList extends Vue {
  @Prop(Object) readonly scenarioParameters!: Models.Scenarios.Model | null;

  @Prop(Boolean) readonly disabled!: boolean;

  isFormValid = true;

  latLngModel = {
    latitude: '',
    longitude: ''
  };

  formRules = {
    longitude: [(v) => (v >= -180 && v <= 180) || !v || 'Podaj wartość między -180 a 180'],
    latitude: [(v) => (v >= -90 && v <= 90) || !v || 'Podaj wartość między -90 a 90'],
  };

  $refs!: {
    autocomplete: any;
  };

  @Watch('scenarioParameters')
  onScenarioParametersChange() : void {
    this.latLngModel.latitude = '';
    this.latLngModel.longitude = '';

    this.$nextTick(() => {
      this.latLngModel.latitude = this.currentLatitude;
      this.latLngModel.longitude = this.currentLongitude;
    });
    this.$refs.autocomplete.clear();
  }

  get currentLatitude() {
    const params = this.scenarioParameters;
    if (!params || !params.location) return '';
    return params.location.coordinates[1].toString();
  }

  get currentLongitude() {
    const params = this.scenarioParameters;
    if (!params || !params.location) return '';
    return params.location.coordinates[0].toString();
  }

  get parameters(): Parameter[] {
    return [
      {
        name: 'address',
        displayName: this.$t('scenarioParameters.setAddress').toString(),
        value: '',
        type: 'address'
      },
      {
        name: 'latitude',
        displayName: this.$t('scenarioParameters.latitude').toString(),
        value: this.latLngModel.latitude || this.currentLatitude,
        type: 'string',
      },
      {
        name: 'longitude',
        displayName: this.$t('scenarioParameters.longitude').toString(),
        value: this.latLngModel.longitude || this.currentLongitude,
        type: 'string',
      },
    ];
  }

  get rules() {
    return (paramName) => this.formRules[paramName] ?? [];
  }

  updateProperty(value, name) {
    this.$emit('update:scenarioParameters', {
      name, value
    });
  }

  updateModel(value, name) {
    this.latLngModel[name] = value;
    this.updateProperty(value, name);
  }

  onPlaceChanged(place) {
    if (place.geometry && place.geometry.location) {
      const lat = place.geometry.location.lat();
      const lng = place.geometry.location.lng();

      this.latLngModel.latitude = lat.toString();
      this.latLngModel.longitude = lng.toString();
      
      this.updateProperty(lat, 'latitude');
      this.updateProperty(lng, 'longitude');
    }
  }

  mounted() {
    this.latLngModel.latitude = this.currentLatitude;
    this.latLngModel.longitude = this.currentLongitude;
  }
}
